unit Auth.Service;

interface

uses
  SysUtils, Web, JS, WEBLib.Dialogs, XData.Web.Connection, XData.Web.Client;

const
  TOKEN_NAME = 'Application.Token';

type
  TOnLoginSuccess = reference to procedure;
  TOnLoginError = reference to procedure(AMsg: string);

  TAuthService = class
  private
    FClient: TXDataWebClient;
    procedure SetToken(AToken: string);
    procedure DeleteToken;
  public
    constructor Create(Connection: TXDataWebConnection); reintroduce;
    destructor Destroy; override;
    procedure Login(AUser, APassword: string; ASuccess: TOnLoginSuccess; AError: TOnLoginError);
    procedure LoginPin(APin: string; ASuccess: TOnLoginSuccess; AError: TOnLoginError);
    procedure LoginStranka(AUser, APassword: string; ASuccess: TOnLoginSuccess; AError: TOnLoginError);
    procedure Logout;
    function GetToken: string;
    function Authenticated: Boolean;
    function TokenExpirationDate: TDateTime;
    function TokenExpired: Boolean;
    function TokenPayload: JS.TJSObject;
    function TokenStrankaId: integer;
  end;

  TJwtHelper = class
  private
    class function HasExpirationDate(AToken: string): Boolean;
  public
    class function TokenExpirationDate(AToken: string): TJSDate;
    class function TokenExpired(AToken: string): Boolean;
    class function DecodePayload(AToken: string): string;
    class function TokenStrankaId(AToken: string): integer;
  end;

//  function AuthService: TAuthService;

implementation

uses
  Client.Core;

{ TAuthService }

function TAuthService.Authenticated: Boolean;
begin
  Result := not isNull(window.localStorage.getItem(TOKEN_NAME)) and (window.localStorage.getItem(TOKEN_NAME) <> '');
end;

constructor TAuthService.Create(Connection: TXDataWebConnection);
begin
  FClient := TXDataWebClient.Create(nil);
  FClient.Connection := Connection;
end;

procedure TAuthService.DeleteToken;
begin
  window.localStorage.removeItem(TOKEN_NAME);
end;

destructor TAuthService.Destroy;
begin
  FClient.Free;
  inherited;
end;

function TAuthService.GetToken: string;
begin
  Result := window.localStorage.getItem(TOKEN_NAME);

  try
//    if Assigned(modMain) then
//      modMain.Log('JWT: '+Result);
  except
  end;
end;

procedure TAuthService.Login(AUser, APassword: string; ASuccess: TOnLoginSuccess; AError: TOnLoginError);

  procedure OnLoad(Response: TXDataClientResponse);
  var
    Token: JS.TJSObject;
  begin
    Token := JS.TJSObject(Response.Result);
    SetToken(JS.toString(Token.Properties['value']));
    ASuccess;
    modMain.Log('Saved JWT');
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    modMain.Log('JWT error: '+Error.ErrorCode+' - '+Error.ErrorMessage);
    AError(Format('%s: %s', [Error.ErrorCode, Error.ErrorMessage]));
  end;

begin
  if (AUser = '') or (APassword = '') then
  begin
    AError('Enter the username and password!');
    Exit;
  end;

  FClient.RawInvoke('IKamijoncinService.Login', [AUser, APassword], @OnLoad, @OnError);
end;

procedure TAuthService.LoginPin(APin: string; ASuccess: TOnLoginSuccess; AError: TOnLoginError);

  procedure OnLoad(Response: TXDataClientResponse);
  var
    Token: JS.TJSObject;
  begin
    Token := JS.TJSObject(Response.Result);
    SetToken(JS.toString(Token.Properties['value']));
    ASuccess;
    modMain.Log('Saved JWT');
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    AError(Format('%s: %s', [Error.ErrorCode, Error.ErrorMessage]));
    modMain.Log('JWT error: '+Error.ErrorCode+' - '+Error.ErrorMessage);
  end;

begin
  if (APin = '') then
  begin
    AError('Enter PIN!');
    Exit;
  end;

  FClient.RawInvoke(
    'IKamijoncinService.LoginPin', [APin],
    @OnLoad, @OnError
  );
end;

procedure TAuthService.LoginStranka(AUser, APassword: string; ASuccess: TOnLoginSuccess; AError: TOnLoginError);

  procedure OnLoad(Response: TXDataClientResponse);
  var
    Token: JS.TJSObject;
  begin
    Token := JS.TJSObject(Response.Result);
    SetToken(JS.toString(Token.Properties['value']));
//    modMain.Log('Saved JWT');
    ASuccess;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    AError(Format('%s: %s', [Error.ErrorCode, Error.ErrorMessage]));
    modMain.Log('JWT error: '+Error.ErrorCode+' - '+Error.ErrorMessage);
  end;

begin
  if (AUser = '') or (APassword = '') then begin
    AError('Enter the username and password!');
    Exit;
  end;

  FClient.RawInvoke('IKamijoncinService.LoginStranka', [AUser, APassword], @OnLoad, @OnError);
end;

procedure TAuthService.Logout;
begin
  DeleteToken;
end;

procedure TAuthService.SetToken(AToken: string);
begin
  window.localStorage.setItem(TOKEN_NAME, AToken);
end;

function TAuthService.TokenExpirationDate: TDateTime;
var
  ExpirationDate: TJSDate;
begin
  if not Authenticated then
    Exit(Now);

  ExpirationDate := TJwtHelper.TokenExpirationDate(GetToken);

  Result := EncodeDate(
              ExpirationDate.FullYear,
              ExpirationDate.Month + 1,
              ExpirationDate.Date
            ) +
            EncodeTime(
              ExpirationDate.Hours,
              ExpirationDate.Minutes,
              ExpirationDate.Seconds,
              0
            );
end;

function TAuthService.TokenExpired: Boolean;
begin
  if not Authenticated then
    Exit(False);
  Result := TJwtHelper.TokenExpired(GetToken);
end;

function TAuthService.TokenPayload: JS.TJSObject;
begin
  if not Authenticated then
    Exit(nil);
  Result := TJSObject(TJSJSON.parse(TJwtHelper.DecodePayload(GetToken)));
end;

function TAuthService.TokenStrankaId: integer;
begin
  Result := TJwtHelper.TokenStrankaId(GetToken);
end;

{ TJwtHelper }

class function TJwtHelper.DecodePayload(AToken: string): string;
begin
  if Trim(AToken) = '' then
    Exit('');
  Result := '';
  asm
    var Token = AToken.split('.');
    if (Token.length = 3) {
      Result = Token[1];
      Result = atob(Result);
    }
  end;
end;

class function TJwtHelper.HasExpirationDate(AToken: string): Boolean;
var
  Payload: string;
  Obj: TJSObject;
begin
  Payload := DecodePayload(AToken);
  Obj := TJSObject(TJSJSON.parse(Payload));
  Result := Obj.hasOwnProperty('exp');
end;

class function TJwtHelper.TokenExpirationDate(AToken: string): TJSDate;
var
  Payload: string;
  Obj: TJSObject;
  Epoch: NativeInt;
begin
  if not HasExpirationDate(AToken) then
    raise Exception.Create('Token has not expiration date');

  Payload := DecodePayload(AToken);
  Obj := TJSObject(TJSJSON.parse(Payload));
  Epoch := toInteger(Obj.Properties['exp']);
  Result := TJSDate.New(Epoch * 1000);
end;

class function TJwtHelper.TokenExpired(AToken: string): Boolean;
begin
  if not HasExpirationDate(AToken) then
    Exit(False);
  Result := TJSDate.now > toInteger(TokenExpirationDate(AToken).valueOf);
end;

class function TJwtHelper.TokenStrankaId(AToken: string): integer;
var
  Payload: string;
  Obj: TJSObject;
begin
  Payload := DecodePayload(AToken);
  Obj := TJSObject(TJSJSON.parse(Payload));
  Result := toInteger(Obj.Properties['strankaid']);
end;

end.
